// authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  forgotDetail: null,
  resetDetail: null,
};

const authSlice = createSlice({
  name: "reset",
  initialState,
  reducers: {
    forgotPassword(state,action) {
      state.forgotDetail = action.payload;
    },
    resetpassword(state,action){
        state.resetDetail= action.payload
    }
    
  },
});

export const { forgotPassword,resetpassword } = authSlice.actions;
export default authSlice.reducer;
